module.exports = __webpack_public_path__ + "img/plant_5.5ed4518a.webp";